export default class Accordion {
	/**
	 * Constructs an instance of the Accordion class.
	 * @param {Element} wrapperSelector - The wrapper element of the accordion.
	 * @memberof Accordion
	 */
	constructor(wrapperSelector) {
		this.wrapper = wrapperSelector;
		this.button  = this.wrapper.querySelector('[data-according="button"]');
	}
	
	/**
	 * Inits accordion.
	 * Adds an event listener to the button and handles its click.
	 * @returns {void}
	 * @memberof Accordion
	 */
	init() {
		this.button.addEventListener('click', () => this.toggleAccordion());
	}
	
	/**
	 * Toggle accordion state
	 * @returns {void}
	 * @memberof Accordion
	 */
	toggleAccordion() {
		// Переключаем состояние текущего аккордеона
		this.wrapper.classList.toggle('is-active');
	}
}
